<template>
  <div>
    <div id="qrcode" ref="qrcode" />
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: 'https://www.baidu.com/'
    },
    width: {
      type: Number,
      default: 200
    },
    height: {
      type: Number,
      default: 190
    },
    title: {
      type: String,
      default: '标题'
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      curQrContent: ''
    }
  },
  computed: {
    curVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$refs.qrcode.innerHTML = ''
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(val, oldval) {
      if (val) {
        this.createQrCode()
      }
    },
    content(val) {
      this.curQrContent = val
    }
  },
  mounted() {

  },
  created() {

  },
  methods: {
    createQrCode() {
      var that = this
      that.$nextTick(() => {
        var qrCode = new QRCode('qrcode', {
          width: that.width - 25,
          height: that.height - 30,
          text: that.curQrContent, // 二维码内容
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.L
        })
        console.log('qrCode', qrCode)
        console.log('curQrContent', that.curQrContent)
      })
    },
    setQrContent(content) {
      var that = this
      that.curQrContent = content
    }
  }
}
</script>

<style scoped>

.us-el-dialog /deep/ .el-dialog__body {
  padding-top: 0px;
}

.us-el-dialog /deep/ .el-dialog__headerbtn {
  font-size: 30px;
}

#qrcode {
  display: inline-block;
  border: 6px solid rgb(255, 255, 255);
  border-radius: 5px;
}
/* #qrcode img {
  width: 132px;
  height: 132px;
  background-color: #fff;
  padding: 6px;
} */

.headline{
  padding: 10px 14px 6px !important;
  font-size: 1.1rem !important;
}

.us-qrcode-toolbar >>> .v-toolbar__content{
  height:46px !important;
}

</style>
